import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const useLanguageListener = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    const handleMessage = (event:any) => {
      if (event.data.type === "LANGUAGE_CHANGED") {
        i18n.changeLanguage(event.data.language);
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [i18n]);
};

export default useLanguageListener;
